import module from 'module';
import StatusBasedService from "./statusBasedService";

module.factory('cashTransferCheckService', (statusService) =>
  new StatusBasedService({
    property: 'waitForCashTransfer',
    statusService: statusService,
    defaultIfEmpty: false
  }));
